module.exports = __webpack_public_path__ + "img/wheelplanting.2a1504d1.png";